/**
 * Adds required polyfills to support older browsers
 */
import '~gatsby-theme-autonomy/utils/polyfills/object'

import WrapWithAllProviders from '~gatsby-theme-autonomy/context/wrap-with-all-providers'

export const wrapRootElement = WrapWithAllProviders
